/** Messages the consult app posts to care-betty when it is framed inside its booking modal. */
export type ConsultEmbedMessage =
  | { type: 'nrx-consult:booked'; consultType: string }
  | { type: 'nrx-consult:error' };

/** True when the page was opened as care-betty's modal iframe (`?embedded=1`). */
export function isEmbedded(search: string = window.location.search): boolean {
  return new URLSearchParams(search).get('embedded') === '1';
}

/**
 * Tell the framing care-betty page what happened.
 *
 * @remarks A no-op unless embedded, actually framed, and `VITE_CARE_BETTY_ORIGIN` is set. The
 * target origin is always that configured origin and never `*`, so a different embedder cannot
 * observe a booking.
 */
export function notifyParent(message: ConsultEmbedMessage): void {
  const origin = import.meta.env.VITE_CARE_BETTY_ORIGIN;
  if (!isEmbedded() || window.parent === window || !origin) return;
  window.parent.postMessage(message, origin);
}
